import React from 'react';
import { Link } from 'react-router-dom';
import Header from "./Header";
// import './DocumentsListPage.css'

interface Content {
    type: 'text' | 'image';
    data: string;
}

interface Document {
    title: string;
    contents: Content[];
}

interface DocumentsListPageProps {
    documents: Document[];
}

const DocumentsListPage: React.FC<DocumentsListPageProps> = ({ documents }) => {
    return (
        <div>
            <div className="documents-sidebar">

                <ul>
                    {documents.map((doc, index) => (
                        <li key={index}>
                            <Link to={`/documentation/${encodeURIComponent(doc.title)}`}>{doc.title}</Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>

    );
};

export default DocumentsListPage;
